<template>
  <div class="page">
      <list-item v-for="item in dataList" :key="item" :data="item"></list-item>
    <div v-if="dataList.length === 0 && canShow">
      <img
        src="../../../assets/list-none.png"
        alt=""
        width="250"
        class="table-empty"
      />
      <div>空荡荡的～暂无数据！</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Utils from "../integral/Utils";
import ListItem from "./ListItem";

export default {
  name: "home",

  components: {
    ListItem
  },

  mounted() {
    addEventListener("scroll", this.handleScroll); //监听函数
  },

  data() {
    return {
      dataList: [],
      canShow: true,
      pageIdx: 0
    };
  },

  created() {
    document.title = "我的卡券";

    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", this.$route.query.client || "");

    Utils.userInfo.token = this.$route.query.token;
    Utils.userInfo.orgID = this.$route.query.orgID;
    Utils.userInfo.userID = this.$route.query.userID;
    this.query();

  },

  methods: {
    goBack() {
      this.$router.back();
    },

    handleScroll() {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        //你想做的事情
        this.pageIdx++;
        this.query();
      }
    },

    //列表查询
    query() {
      let data = {
        orgID: Utils.userInfo.orgID,
        userID: Utils.userInfo.userID,
        pageSize: 10,
        pageIdx: this.pageIdx
      };
 let url = axios.defaults.baseURL.replace('v1/org/','')
      axios({
        method: "post",
        url: url+"v2/users/coupons",
        headers: { 
           'Authorization': this.$route.query.token,
            'PYDDot-Client-Type':this.$route.query.client,
            'X-Ca-Timestamp':parseInt(new Date().getTime()/1000)
        },
        data: data
      })
        .then(value => {
          if (value && value.data && value.data.data) {
            value.data.data.forEach(data => {
                if(data.endTime === 0) {
                    data.timeStr = "永久";
                }
                else {
                    data.timeStr = Utils.long2second(data.endTime * 1000);
                }
              this.dataList.push(data);
            });
          }
        })
        .catch(() => {})
        .finally(_ => {
          this.canShow = true;
          // this.dataList.push({
          //   name: "得到的点点滴滴点点滴滴点点滴滴",
          //   code: "ddddddd",
          //   timeStr: "ddddddd",
          //   type: "现金券",
          // });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.page {
  box-sizing: border-box;
}
.table-empty {
  margin-top: 200px;
}
</style>
